export default __webpack_public_path__ + "static/media/convocatoriabarrio2.c558d999.jpeg";